import React from 'react';
import { Helmet } from "react-helmet";

const CommunityHelmet = ({ community, domain }) => {
    if (community?.brandingSource === 'ADMIN') {
        return (
            <Helmet>
                {community.seoTitle ? <title>{community.seoTitle}</title> : null}
                {community.seoDescription ? (
                    <meta name="description" content={community.seoDescription} />
                ) : null}
                {community.faviconUrl ? (
                    <link rel="icon" href={community.faviconUrl} />
                ) : null}
            </Helmet>
        );
    }

    const resolvedDomain = community?.domain || domain;
    let helmet = ''
    if (resolvedDomain === 'annamoney') {
        helmet = (
            <Helmet>
                <title>ANNA Community by Volee</title>
                <meta name="description" content="Join our growing community of entrepreneurs and start promoting your business for free" />
                <link rel="manifest" href="/community/annamoney/assets/favicons/manifest.json" />
                <link rel="icon" href="/community/annamoney/assets/favicons/favicon.ico" />
                <link rel="icon" type="image/png" sizes="120x120" href="/community/annamoney/assets/favicons/anna-favicon.png" />
                <link rel="icon" type="image/png" sizes="192x192" href="/community/annamoney/assets/favicons/icon192.png" />
                <link rel="icon" type="image/png" sizes="144x144" href="/community/annamoney/assets/favicons/icon144.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/community/annamoney/assets/favicons/icon32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/community/annamoney/assets/favicons/icon16.png" />
                <link rel="mask-icon" href="/community/annamoney/assets/favicons/safari_tab.svg" color="#5bbad5" />
                <meta name="msapplication-TileColor" content="#da532c" />
                <meta name="theme-color" content="#ffffff" />
            </Helmet>
        )
    } else if (resolvedDomain === 'rc') {
        helmet = (
            <Helmet>
                <title>Сообщество Southub</title>
            </Helmet>
        )
    } else if (resolvedDomain === 'nw') {
        helmet = (
            <Helmet>
                <title>Сообщество предпринимателей банка Ренессанс Кредит</title>
                <link rel="icon" type="image/png" sizes="120x120" href="/community/nw/assets/favicon.png" />
                <meta property="og:title" content="Сообщество предпринимателей банка Ренессанс Кредит"></meta>
                <meta property="description" name="description" content="Meetsup – комьюнити платформа для создания и управления онлайн сообществами." data-react-helmet="true" />
            </Helmet>
        )
    } else if (resolvedDomain === 'jewishpoint') {
        helmet = (
            <Helmet>
                <title>Networking JP</title>
                <link rel="icon" type="image/png" sizes="120x120" href="/community/jewishpoint/assets/favicon_jp.png" />
            </Helmet>
        )
    } else if (resolvedDomain === 'ciao') {
        helmet = (
            <Helmet>
                <title>Ciao, Imprenditore Community</title>
                <link rel="icon" type="image/png" sizes="32x32" href="/community/ciao/assets/favicons/icon32.png" />
            </Helmet>
        )
    } else if (resolvedDomain === 'multicarta') {
        helmet = (
            <Helmet>
                <title>Сообщество Мультикарта</title>
                <link rel="icon" type="image/png" sizes="32x32" href="/community/multicarta/assets/favicons/icon32.png" />
            </Helmet>
        )
    } else if (resolvedDomain === 'sfeducation') {
        helmet = (
            <Helmet>
                <title>SF Education Community</title>
                <link rel="icon" type="image/png" sizes="32x32" href="/community/sfeducation/assets/favicons/icon32.png" />
            </Helmet>
        )
    } else if (resolvedDomain === 'columbiaalumni') {
        helmet = (
            <Helmet>
                <title>Unofficial Columbia Business School Biotech Community</title>
            </Helmet>
        )
    } else if (resolvedDomain === 'bue') {
        helmet = (
            <Helmet>
                <link rel="manifest" href="/community/bue/assets/favicons/manifest.json" />
                <link rel="icon" href="/community/bue/assets/favicons/favicon.ico" />
            </Helmet>
        )
    } else if (resolvedDomain === 'ex') {
        helmet = (
            <Helmet>
                <title>Добро пожаловать в сообщество бывших сотрудников Авито!</title>
                <meta name="description" content="Это пространство для тех, кто покинул компанию, но кто хочет оставаться на связи, делиться своими успехами и благодаря нетворкингу решать бизнес-задачи." />
                <link rel="manifest" href="/community/alumni/assets/favicons/manifest.json" />
                <link rel="icon" href="/community/alumni/assets/favicons/favicon.ico" />
            </Helmet>
        )
    } else if (resolvedDomain === 'tlfcommunity') {
        helmet = (
            <Helmet>
                <title>TLF Community Club</title>
                <link rel="manifest" href="/community/tlfcommunity/assets/favicons/site.webmanifest" />
                <link rel="icon" href="/community/tlfcommunity/assets/favicons/favicon.ico" />
                <link rel="icon" type="image/svg+xml" href="/community/tlfcommunity/assets/favicons/favicon.svg" />
                <link rel="icon" type="image/png" sizes="96x96" href="/community/tlfcommunity/assets/favicons/favicon-96x96.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/community/tlfcommunity/assets/favicons/icon32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/community/tlfcommunity/assets/favicons/icon16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/community/tlfcommunity/assets/favicons/apple-touch-icon.png" />
                <meta name="theme-color" content="#770101" />
            </Helmet>
        )
    } else {
        helmet = (
            <Helmet>
                <meta property="og:site_name" content={resolvedDomain} />
                <meta property="og:title" content={resolvedDomain} />
            </Helmet>
        )
    }
    return helmet
};

export default CommunityHelmet;
